<template>
    <div class="home">
        <div class="main" ref="mainWrap">
            <div class="sizeBox" ref="sizeBox"></div>

            <!-- 游戏机外壳 -->
            <div
                class="game-box"
                ref="gameBox"
                :style="{
                    transform:
                        'translate(-50%, -50%) scale(' + gameBoxScale + ')'
                }"
            >
                <!-- 顶部按钮 -->
                <topbar></topbar>
                <!-- koa 文字logo -->
                <div class="koa-logo"></div>
                <!-- 游戏机屏幕 -->
                <div class="game-screen">
                    <!-- <popup /> -->
                    <gameview />
                </div>
                <!-- 底部按钮 -->
                <toolbar></toolbar>
            </div>
            <!-- 底部版权 -->
            <p class="copyright"></p>
            <Loading :progress="loadProgress" />
            <popup-share></popup-share>
            <saveSharePic />
            <waitingMask />
            <popup />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { CONFIG } from '@/config/index';
import { urlParser, getQueryString, isIOS, isAndroid } from '@/utils';
import { Bus } from '@/utils/eventBus.js';
import LS from '@/utils/storage.js';
import { LS_PREFIX } from '@/config';
import Loading from '@/components/loading';
import topbar from '@/components/topbar';
import toolbar from '@/components/toolbar';
import popup from '@/components/popup';
import popupShare from '@/components/popup/popup-share';
import gameview from '@/components/gameview';
import saveSharePic from '@/components/game/save-share-pic';
import waitingMask from '@/components/waiting-mask';
// import PopupComm from './popup-comm.vue';
// 游戏
import 'script-loader!createjs/builds/1.0.0/createjs.min.js';
import '@/game/ani-test.js';
import aniClass from '@/game/game.js';
window.gameAni = null; // 游戏实例
export default {
    name: 'Home',
    components: {
        Loading,
        topbar,
        toolbar,
        popup,
        popupShare,
        gameview,
        saveSharePic,
        waitingMask
    },
    data() {
        return {
            loadProgress: 0,
            gameBoxScale: 1
        };
    },
    methods: {
        ...mapMutations([
            'SHOW_POPUP',
            'SET_LANG',
            'SET_GAME_STATE',
            'SET_STATE'
        ]),
        ...mapActions([
            'getAuthLocation',
            'getUserInfo',
            'getToken',
            'getConfigs',
            'getTagList',
            'getStarList',
            'getDragonList',
            'getBattleList'
        ]),
        // 必要数据
        async initBaseData() {
            const config = this.getConfigs(); // 活动配置
            const tagList = this.getTagList(); // 标签列表
            const starList = this.getStarList(); // 星座列表
            const dragonList = this.getDragonList(); // 龙列表
            const pkwordsList = this.getBattleList(); // 对战文案列表
            const configRes = await config;
            const tagListRes = await tagList;
            const starListRes = await starList;
            const dragonListRes = await dragonList;
            const pkwordsListRes = await pkwordsList;
            // console.log('都请求完啦！开始初始化游戏实例');

            // 标签数据
            if (tagListRes.code == 1) {
                this.SET_GAME_STATE({
                    key: 'tags',
                    value: tagListRes.data
                });
                Bus.$emit('_handleTags');
            }
            // 星座数据
            if (starListRes.code == 1) {
                this.SET_GAME_STATE({
                    key: 'star',
                    value: starListRes.data
                });
            }
            // 初始化龙列表
            if (dragonListRes.code == 1) {
                this.SET_GAME_STATE({
                    key: 'dragonList',
                    value: dragonListRes.data
                });
                // gameAni.setDragonData(dragonListRes.data);// 0710
            }
            // 添加/更新 pk文案
            if (pkwordsListRes.code == 1) {
                this.SET_GAME_STATE({
                    key: 'pkwordsList',
                    value: pkwordsListRes.data
                });
                // gameAni.updatePkWords(pkwordsListRes.data);// 0710
            }
        },
        // 登录检查
        async loginFun() {
            const myurl = urlParser(location.href);
            const token = LS.get(LS_PREFIX + 'token');
            // 打点
            if (myurl.data('userid')) {
                // 分享
                this.$LOG.send_pv_sharelink();
            } else {
                // 主链
                this.$LOG.send_pv_mainlink();
            }
            if (token) {
                this.SET_STATE({
                    key: 'token',
                    val: token
                });
                // Bus.$emit('_goPage', 'empty'); // 先清屏// 0710
                await this.initBaseData();
                await this.getUserInfo();
                // 初始化动画
                this.initAnimation();
            } else {
                // 未授权流程   无code
                const code = myurl.data('code');
                const channel = myurl.data('channel');
                console.log('code:', code);
                console.log('channel:', channel);
                if (code && channel) {
                    await this.initBaseData(); // 等待基础数据获取完成再进行登录
                    this.getToken({
                        channel,
                        code,
                        redirect_uri: CONFIG.domain + '/h5/authCallback.html'
                    });
                    // 初始化动画
                    this.initAnimation();
                    // Bus.$emit('_goPage', 'empty'); // 先清屏// 0710
                } else {
                    // 未登录
                    // Bus.$emit('_goPage', 'start'); // 登录前动画// 0710
                    // 初始化动画
                    this.initAnimation();
                }
            }
        },
        // 加载完成
        async loadCompleted() {
            // gameAni.lang = this.$store.state.lang;
            const myurl = urlParser(location.href);
            this.loadProgress = 100; // 进度100
            const token = LS.get(LS_PREFIX + 'token');
            // 打点
            if (myurl.data('userid')) {
                // 分享
                this.$LOG.send_pv_sharelink();
            } else {
                // 主链
                this.$LOG.send_pv_mainlink();
            }
            if (token) {
                this.SET_STATE({
                    key: 'token',
                    val: token
                });
                await this.initBaseData();
                await this.getUserInfo();
                Bus.$emit('_goPage', 'empty'); // 先清屏
            } else {
                // 未授权流程   无code
                const code = myurl.data('code');
                const channel = myurl.data('channel');
                console.log('code:', code);
                console.log('channel:', channel);
                if (code && channel) {
                    await this.initBaseData(); // 等待基础数据获取完成再进行登录
                    this.getToken({
                        channel,
                        code,
                        redirect_uri: CONFIG.domain + '/h5/authCallback.html'
                    });
                    Bus.$emit('_goPage', 'empty'); // 先清屏
                } else {
                    // 未登录
                    Bus.$emit('_goPage', 'start'); // 登录前动画
                }
            }
        },
        // 初始化游戏
        initGame(lib) {
            // 初始化游戏
            gameAni = new aniClass({
                lib: lib
            });
            console.log(gameAni);
            gameAni.lang = this.$store.state.lang; // 设置首屏弹幕语言
            // 存储游戏
            this.SET_GAME_STATE({
                key: 'canPk',
                value: true
            });
        },
        // 初始化动画
        initAnimation() {
            let _this = this;
            var canvas,
                stage,
                anim_container,
                dom_overlay_container,
                fnStartAnimation;

            // let filesMap = require.context('../assets/img', false, /.jpg|png$/);
            // let imgs = [];
            // for (let i = 0; i < filesMap.keys().length; i++) {
            //     let _files = filesMap.keys()[i];
            //     imgs.push(
            //         require('../assets/img/' +
            //             _files.substring(2, _files.length))
            //     );
            // }
            let imgs = [];
            imgs.push(
                require('@/assets/img/lottery_en_bg.png'),
                require('@/assets/img/lottery_ru_bg.png'),
                require('@/assets/img/pop_fri_frame.png'),
                require('@/assets/img/game/bg_share_1.png'),
                require('@/assets/img/game/bg_share_2.png')
            );

            init();
            function init() {
                canvas = document.getElementById('canvas');
                anim_container = document.getElementById('animation_container');
                dom_overlay_container = document.getElementById(
                    'dom_overlay_container'
                );
                var comp = AdobeAn.getComposition(
                    'EC8E2C9BC49BE74590BBF29685F20A65'
                );
                var lib = comp.getLibrary();
                var loader = new createjs.LoadQueue(true);
                loader.setMaxConnections(100);
                loader.maintainScriptOrder = true;
                // loader.installPlugin(createjs.Sound); // soundjs
                loader.addEventListener('fileload', function(evt) {
                    handleFileLoad(evt, comp);
                });
                loader.addEventListener('progress', function(evt) {
                    _this.loadProgress = Math.ceil(evt.progress * 100);
                });
                loader.addEventListener('complete', function(evt) {
                    handleComplete(evt, comp);
                });
                var lib = comp.getLibrary();
                let _source = lib.properties.manifest;
                _source = _source.concat(imgs);
                loader.loadManifest(_source);
            }

            function handleFileLoad(evt, comp) {
                var images = comp.getImages();
                if (evt && evt.item.type == 'image') {
                    images[evt.item.id] = evt.result;
                }
            }

            function handleComplete(evt, comp) {
                //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
                var lib = comp.getLibrary();
                var ss = comp.getSpriteSheet();
                var queue = evt.target;
                var ssMetadata = lib.ssMetadata;
                for (let i = 0; i < ssMetadata.length; i++) {
                    ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                        images: [queue.getResult(ssMetadata[i].name)],
                        frames: ssMetadata[i].frames
                    });
                }
                window.exportRoot = new lib.anitest();
                stage = new lib.Stage(canvas);
                //Registers the "tick" event listener.
                fnStartAnimation = function() {
                    stage.addChild(exportRoot);
                    // createjs.Ticker.setFPS(lib.properties.fps);
                    // createjs.Ticker.setFPS(30);
                    createjs.Ticker.framerate = 30;
                    createjs.Ticker.addEventListener('tick', function() {
                        stage.update();
                    });
                    // 实例化游戏
                    _this.initGame(lib);
                };
                AdobeAn.compositionLoaded(lib.properties.id);
                fnStartAnimation();

                // 加载完成
                // _this.loadCompleted();// 0710
            }
        },
        // 初始化音乐
        initSound() {
            var sounds = [
                {
                    src: require('../assets/music/bgm.mp3'),
                    id: 'bgm'
                },
                {
                    src: require('../assets/music/battle.mp3'),
                    id: 'battle'
                },
                {
                    src: require('../assets/music/button.mp3'),
                    id: 'button'
                },
                {
                    src: require('../assets/music/victory.mp3'),
                    id: 'victory'
                }
            ];
            if (isIOS) {
                createjs.Sound.registerPlugins([createjs.WebAudioPlugin]);
            } else {
                createjs.Sound.registerPlugins([createjs.HTMLAudioPlugin]);
            }
            createjs.Sound.alternateExtensions = ['mp3'];
            createjs.Sound.on('fileload', loadSound);
            createjs.Sound.registerSounds(sounds);
            // 加载完成后
            function loadSound() {
                // console.log('音频资源加载完毕');
                // createjs.Sound.play('bgm');
            }
        },
        // 适配游戏机大小
        resizeGameBox() {
            let $sizeBox = this.$refs.sizeBox;
            let _game_w = 738; // 游戏机宽
            let _game_h = 1308; // 游戏机高
            let _main_w = $sizeBox.offsetWidth; // 游戏盒子外部宽高
            let _main_h = $sizeBox.offsetHeight; // 游戏盒子外部宽高
            // console.log(555, _main_w, _main_h);
            let _scale = 1;

            // 游戏机高 > 容器高
            if (_main_w / _main_h >= _game_w / _game_h) {
                _scale = ((_main_h / _main_w) * 750) / 1308;
            }
            this.gameBoxScale = _scale;
        }
    },
    mounted() {
        // 登录
        // this.loginFun();
        // // 初始化动画
        // // this.initAnimation();
        // // 初始化音乐
        // this.initSound();
        // // 适配游戏机大小
        // this.resizeGameBox();
    }
};
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    height: 100%;
    background: url(~@/assets/img/bg.jpg) top center/cover no-repeat;
    // padding-top: 58px;

    // @media screen and (max-height: 600px) {
    //     padding-top: 22px;
    // }

    .main {
        width: 100%;
        height: 100%;
        padding: 34px 0 70px;
        box-sizing: border-box;

        .sizeBox {
            position: absolute;
            top: 34px;
            left: 0;
            right: 0;
            bottom: 70px;
            pointer-events: none;
        }
    }

    .game-box {
        width: 738px;
        height: 1308px;
        background: url(~@/assets/img/game_box.png) center/100% 100% no-repeat;
        margin: 0 auto;
        position: relative;
        // transform-origin: top center;
        z-index: 1;
        top: 50%;
        left: 50%;

        // @media screen and (max-height: 667px) {
        //     transform: scaleY(0.9) scaleX(0.95);
        // }

        // @media screen and (max-height: 590px) {
        //     transform: scaleY(0.84) scaleX(0.92);
        // }

        // @media screen and (max-height: 550px) {
        //     transform: scaleY(0.76) scaleX(0.9);
        // }

        // @media screen and (min-width: 413px) and (max-height: 736px) {
        //     transform: scaleY(0.9) scaleX(0.95);
        // }

        // @media screen and (min-width: 413px) and (max-height: 650px) {
        //     transform: scaleY(0.8) scaleX(0.92);
        // }

        // @media screen and (min-width: 413px) and (max-height: 560px) {
        //     transform: scaleY(0.72) scaleX(0.88);
        // }

        .koa-logo {
            width: 294px;
            height: 57px;
            background: url(~@/assets/img/koa_icon2.png) center/100% 100%
                no-repeat;
            position: absolute;
            right: 84px;
            top: 12px;
        }

        .game-screen {
            width: 596px;
            height: 807px;
            position: absolute;
            top: 245px;
            left: 72px;
            // background: url(~@/assets/img/bg2.png) center/100% 100% no-repeat;
        }

        .topbar {
            position: absolute;
            top: 92px;
            left: 38px;
        }

        .toolbar {
            position: absolute;
            bottom: 76px;
        }
    }

    .copyright {
        width: 380px;
        height: 70px;
        background: url(~@/assets/img/copyright1.png) center/100% 26px no-repeat;
        position: absolute;
        left: 50%;
        margin-left: -190px;
        bottom: 0;
    }
}
</style>
